(function () {
  var CONFIG_ID = 'vetstor-mobile-app-banner-config';
  var BANNER_ID = 'vetstor-mobile-app-banner';
  var TEMPLATE_ID = 'vetstor-mobile-app-banner-template';
  var DISMISS_KEY = 'vetstor_app_banner_dismissed';

  var ua = navigator.userAgent;
  var platform = /Android/i.test(ua) ? 'android' : /iPhone|iPad|iPod/i.test(ua) ? 'ios' : 'other';

  function phCapture(event, props, options) { try { window.posthog && window.posthog.capture(event, props, options); } catch (_) {} }

  function isVetstorApp() {
    return navigator.userAgent.includes('vetstor-mobile');
  }

  function isMobile() {
    return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
  }

  function isAndroid() {
    return /Android/i.test(navigator.userAgent);
  }

  // intent:// is Chromium-only; Firefox on Android ignores it.
  function isAndroidChromium() {
    return isAndroid() && !/Firefox|FxA/i.test(navigator.userAgent);
  }

  function isCriOS() {
    return /CriOS/i.test(navigator.userAgent);
  }

  function isIOS() {
    return (
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    );
  }

  // In-app browsers and the Google app append their token to a full Safari UA ("... Safari/604.1
  // [FBAN/...]"), so they must be matched before the Safari fallback.
  // Mirrors browserOf() in universal apps/storefront/lib/app-banner.ts.
  function browserOf(ua) {
    if (/Instagram/.test(ua)) return 'instagram';
    if (/FBAN|FBAV/.test(ua)) return 'facebook';
    if (/GSA\//.test(ua)) return 'google_app';
    if (/CriOS|Chrome\//.test(ua) && !/EdgiOS|EdgA|Edg\/|OPiOS|OPR\/|SamsungBrowser/.test(ua)) return 'chrome';
    if (/FxiOS|Firefox/.test(ua)) return 'firefox';
    if (/iPad|iPhone|iPod|Macintosh/.test(ua) && /Safari\//.test(ua) && !/EdgiOS|OPiOS/.test(ua)) return 'safari';
    return 'other';
  }

  var browser = browserOf(ua);

  function readConfig() {
    var el = document.getElementById(CONFIG_ID);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (_) {
      return null;
    }
  }

  // The bridge page decides login state server-side and hands the app either a
  // multipass URL or the login page — no client fetch needed here. Navigation
  // to the app MUST stay synchronous inside the click: an await first drops
  // the user gesture and Chromium silently ignores intent://vetstor:// (VTSR-2648).
  function bridgeUrl(config) {
    return (
      config.storeOrigin +
      '/pages/app-handoff?return_to=' +
      encodeURIComponent(config.returnTo) +
      '&vt_src=banner'
    );
  }

  function appTarget(config) {
    return config.activationUrl ? config.storeOrigin + config.activationUrl : bridgeUrl(config);
  }

  // Storefront host on purpose: iOS ignores a UL tapped on the same domain. Safari's vetstor://
  // throws "invalid address" when not installed; FB/IG block custom schemes.
  function usesUniversalLink(config) {
    return !!config.appOpenUrl && isIOS() && (browser === 'safari' || browser === 'facebook' || browser === 'instagram');
  }

  // The mint rides in the fragment so it never reaches the storefront server or its logs.
  function universalLinkUrl(config, minted) {
    var url = config.appOpenUrl + '?url=' + encodeURIComponent(appTarget(config)) + '&vt_src=banner';
    return minted ? url + '#mp=' + encodeURIComponent(minted) : url;
  }

  function storeListingUrl(config) {
    if (isAndroid()) {
      // DEV-2984: utm_source for Play Console. VTSR-activation: activation_path carries the
      // activation URL through a cold install so the app can resume after Play onboards the user.
      var referrerParts = ['utm_source=app_banner'];
      if (config.activationUrl) {
        referrerParts.push('activation_path=' + encodeURIComponent(config.activationUrl));
      }
      return (
        'https://play.google.com/store/apps/details?id=' +
        config.androidPackage +
        '&referrer=' +
        encodeURIComponent(referrerParts.join('&'))
      );
    }
    // DEV-2984: ct = App Analytics campaign token. pt (provider token) is optional and only
    // appended when the snippet supplies it — App Store Connect provider id, filled when known.
    return (
      'https://apps.apple.com/app/id' +
      config.iosAppId +
      '?ct=app_banner' +
      (config.iosProviderToken ? '&pt=' + config.iosProviderToken : '')
    );
  }

  // Target the vetstor:// scheme the app owns — NOT scheme=https at the bridge path.
  // DEV-3012 unclaimed /pages/app-handoff from Android App Links to break the handoff
  // loop, so an https intent at that path no longer resolves and Chromium drops even
  // installed users to the Play Store. The app runs the same bridge handoff from the
  // scheme URL. Not installed -> browser_fallback_url = Play Store (VTSR-2647/2649).
  function androidIntentUrl(httpsUrl, config) {
    return (
      'intent://open?url=' +
      encodeURIComponent(httpsUrl) +
      '#Intent;scheme=' +
      config.appScheme +
      ';package=' +
      config.androidPackage +
      ';S.browser_fallback_url=' +
      encodeURIComponent(storeListingUrl(config)) +
      ';end'
    );
  }

  // Custom scheme has no built-in fallback; decide at fire time. visibilitychange(hidden)/
  // pagehide/blur catch the app taking over. iOS Chrome (CriOS) is special: its "Open in Vetstor?"
  // OS overlay fires none of those while it's up, so an installed-but-still-deciding user looks
  // identical to a no-app user at fire time. We can't tell them apart — so instead of skipping
  // the fallback entirely (was DEV-3018), give CriOS a longer 2s window and redirect to the
  // store unless the app actually opened. A real open backgrounds the tab → document.hidden or
  // the late-timer backstop → suppressed. Trade-off inherent to CriOS: a user who sits on the
  // overlay past the window (or dismisses it) still lands on the store (DEV-2607/DEV-3018).
  // blur only on iOS, where Safari (whose "invalid address" alert also blurs, DEV-2607) always
  // takes the Universal Link instead; iOS Firefox opens the app without firing visibilitychange
  // before the timer, which sent installed users to the App Store (DEV-3033).
  // ponytail: an unrelated backgrounding also suppresses the fallback — re-tap recovers.
  function openViaSchemeWithFallback(httpsUrl, config) {
    var appLikelyOpened = false;
    var mark = function (e) {
      if (e.type !== 'visibilitychange' || document.hidden) {
        appLikelyOpened = true;
      }
    };
    document.addEventListener('visibilitychange', mark);
    window.addEventListener('pagehide', mark);
    if (isIOS()) window.addEventListener('blur', mark);

    // CriOS gets a longer window: its overlay fires no events, so we wait 2s before assuming
    // "no app". Other browsers keep the proven 1600ms.
    var delay = isCriOS() ? 2000 : 1600;
    var scheduledAt = Date.now();

    setTimeout(function () {
      document.removeEventListener('visibilitychange', mark);
      window.removeEventListener('pagehide', mark);
      window.removeEventListener('blur', mark);
      // Timer throttled well past its delay = tab was backgrounded = app opened.
      var late = Date.now() - scheduledAt > delay + 800;
      if (appLikelyOpened || document.hidden || late) return;
      // Genuine store fallback only — after the app-opened guard short-circuits.
      phCapture('app_banner_store_fallback', { page: location.pathname, platform: platform, browser: browser, store_target: isAndroid() ? 'playstore' : 'appstore' });
      window.location.href = storeListingUrl(config);
    }, delay);

    window.location.href =
      config.appScheme + '://open?url=' + encodeURIComponent(httpsUrl);
  }

  // DEV-2622: mint the multipass in THIS browser (it holds the session cookie) instead of
  // the app's ASWebAuthenticationSession, which reads only Safari's jar and so misses a
  // Chrome/Firefox login. Mint ahead of the tap; VTSR-2648 needs the deep-link synchronous.
  var mintedMultipass = null; // { url, at }
  var MULTIPASS_MAX_AGE_MS = 12 * 60 * 1000; // < Shopify multipass TTL (15 min)

  function prefetchMultipass(config) {
    if (!config.loggedIn || isAndroid()) return; // Android Custom Tab already shares cookies
    fetch(
      '/a/v/api/mobile-handoff?return_to=' + encodeURIComponent(config.returnTo),
      { credentials: 'same-origin', cache: 'no-store' },
    )
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (data) {
        if (data && data.url) mintedMultipass = { url: withBannerTag(data.url), at: Date.now() };
      })
      .catch(function () {});
  }

  // The return_to is sealed in the token; the app attributes app_entry from this URL's vt_src.
  // Mirrors withBannerTag() in universal apps/storefront/lib/app-banner.ts.
  function withBannerTag(url) {
    var u = new URL(url);
    u.searchParams.set('vt_src', 'banner');
    return u.toString();
  }

  function takeFreshMultipass() {
    if (mintedMultipass && Date.now() - mintedMultipass.at < MULTIPASS_MAX_AGE_MS) {
      var url = mintedMultipass.url;
      mintedMultipass = null; // single-use
      return url;
    }
    return null;
  }

  var REOPEN_LOCK_MS = 5000;
  var reopenLockUntil = 0;

  // Never use a multipass for activation URLs — the activation endpoint handles its own auth.
  // A claimed mint locks re-taps so a second one doesn't fall back to the Safari-jar bridge and
  // clobber the multipass login already in flight (DEV-2622); the cache is single-use, so re-arm.
  function claimMultipass(config) {
    var minted = (isAndroid() || config.activationUrl) ? null : takeFreshMultipass();
    if (minted) {
      reopenLockUntil = Date.now() + REOPEN_LOCK_MS;
      prefetchMultipass(config);
    }
    return minted;
  }

  function openInNativeApp(config) {
    // Activation pages bypass the bridge — deep-link straight to the activation URL so the
    // app receives the token directly (bridge sends logged-out visitors to /account/login).
    var target = appTarget(config);
    if (isAndroidChromium()) {
      window.location.href = androidIntentUrl(target, config);
      return;
    }
    if (Date.now() < reopenLockUntil) return;
    openViaSchemeWithFallback(claimMultipass(config) || target, config);
  }

  function isDismissed() {
    try {
      return sessionStorage.getItem(DISMISS_KEY) === '1';
    } catch (_) {
      return false;
    }
  }

  function dismissBanner(banner) {
    phCapture('app_banner_dismissed', { page: location.pathname, platform: platform, browser: browser });
    try {
      sessionStorage.setItem(DISMISS_KEY, '1');
    } catch (_) {}
    banner.hidden = true;
    document.body.classList.remove('vetstor-mobile-app-banner-visible');
  }

  function showCustomBanner(config) {
    // No storefront origin = the snippet emits Apple's Smart Banner meta for Safari instead.
    if ((browser === 'safari' && isIOS() && !config.appOpenUrl) || isDismissed()) return;
    var universal = usesUniversalLink(config);

    var banner = document.getElementById(BANNER_ID);
    if (!banner) {
      var template = document.getElementById(TEMPLATE_ID);
      if (!template) return;

      banner = document.createElement('div');
      banner.id = BANNER_ID;
      banner.className = 'vetstor-mobile-app-banner';
      banner.appendChild(template.content.cloneNode(true));
      document.body.prepend(banner);

      banner
        .querySelector('.vetstor-mobile-app-banner__close')
        .addEventListener('click', function () {
          dismissBanner(banner);
        });
    }

    var openLink = banner.querySelector('.vetstor-mobile-app-banner__open');
    openLink.href = universal ? universalLinkUrl(config) : appTarget(config);
    openLink.onclick = function (event) {
      var props = { page: location.pathname, platform: platform, browser: browser, logged_in: config.loggedIn || false, target: universal ? 'app_open' : isAndroidChromium() ? 'android_intent' : 'app_scheme', mint_ready: !!mintedMultipass, is_activation: !!config.activationUrl };
      if (universal) {
        if (Date.now() < reopenLockUntil) {
          event.preventDefault();
          return;
        }
        // Set before the default action runs: iOS honours a UL most reliably on a real link tap.
        openLink.href = universalLinkUrl(config, claimMultipass(config));
        // Drop the spent mint once navigation has started so a long-press copy/share can't leak it.
        setTimeout(function () { openLink.href = universalLinkUrl(config); }, 0);
        // sendBeacon so the event survives the page being left.
        phCapture('app_banner_tapped', props, { transport: 'sendBeacon' });
        return;
      }
      event.preventDefault();
      phCapture('app_banner_tapped', props);
      openInNativeApp(config);
    };
    banner.hidden = false;
    document.body.classList.add('vetstor-mobile-app-banner-visible');
    phCapture('app_banner_shown', { page: location.pathname, platform: platform, browser: browser, logged_in: config.loggedIn || false, is_activation: !!config.activationUrl });
    // Mint the multipass now so it's cached and ready to deep-link synchronously on tap.
    // Skip on activation pages (target is the activation URL).
    if (!config.activationUrl) prefetchMultipass(config);
  }

  function boot() {
    if (isVetstorApp() || !isMobile()) return;

    var config = readConfig();
    if (!config) return;

    showCustomBanner(config);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
